import { render, staticRenderFns } from "./vxe-pagination-table.vue?vue&type=template&id=62731f22&scoped=true"
import script from "./vxe-pagination-table.vue?vue&type=script&lang=js"
export * from "./vxe-pagination-table.vue?vue&type=script&lang=js"
import style0 from "./vxe-pagination-table.vue?vue&type=style&index=0&id=62731f22&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62731f22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62731f22')) {
      api.createRecord('62731f22', component.options)
    } else {
      api.reload('62731f22', component.options)
    }
    module.hot.accept("./vxe-pagination-table.vue?vue&type=template&id=62731f22&scoped=true", function () {
      api.rerender('62731f22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vxe-pagination-table/vxe-pagination-table.vue"
export default component.exports